// Module
var code = "<p><a href=\"https://www.pheaa.org/about/contact-us/office-consumer-advocacy\" target=\"_blank\" class=\"button--isCTALinkWithArrow\">Office of Consumer Advocacy</a></p> ";
// Exports
export default code;